module.exports = __webpack_public_path__ + "macbook-carbon-calculator.0e82cacf318069804e0066044ca79d05.png";